import { getAddressDetails, getAddressesLookup, searchUri } from './addressService';

/**
 * custom utility methods to communicate with the address api service
 */
const addressService = {
  searchUri,
  getAddressDetails,
  getAddressesLookup
};
export { addressService };

export { default as PaymentInstrumentService } from './PaymentInstrumentService';

/**
 * FileUpload API service utils
 */
export * as fileService from './fileService';
